import React from 'react';

const RejectedTimeSheetsEmployee = () => {
    return (
        <div style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
            <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                What should I do if my timesheet is rejected?
            </h3>
            <ul style={{ fontSize: "16px", color: "#333", lineHeight: "1.5", paddingLeft: "20px" }}>
                <li>This section displays timesheets that have been rejected by the approval manager or super admin due to submission issues.</li>
                <li>Employees can review the comments provided and correct their timesheets accordingly.</li>
                <li>Steps to resubmit a rejected timesheet:</li>
                <ul style={{ paddingLeft: "20px" }}>
                    <li>Go to the <strong>Rejected Sheets</strong> section.</li>
                    <li>Select the rejected sheet and open it.</li>
                    <li>Enter the correct billable hours.</li>
                    <li>Upload the required attachment.</li>
                    <li>Click the <strong>Submit</strong> button to resubmit the timesheet for approval.</li>
                </ul>
                <li>If your timesheet is rejected, make sure to correct the errors before resubmitting.</li>
            </ul>

            <img
                style={{ width: "60%", borderRadius: "8px", marginTop: "10px" }}
                src="https://res.cloudinary.com/danfpnuui/image/upload/v1737353072/Rejected_sheets-1_qylve2.png"
                alt="Rejected Sheets Screenshot"
            />

            <p style={{ fontSize: "16px", color: "#00000", marginTop: "15px" }}><h4>Note:</h4>
             If your timesheet is rejected, go to the Rejected Sheets section, find the rejected timesheet, open it, re-enter your billable hours, and upload the required attachment. Click submit to send the corrected timesheet for approval.
            </p>
        </div>
    );
};

export default RejectedTimeSheetsEmployee;
